// society's subdomain (e.g. "Gamla Enskede" -> "gamla-enskede", "Göteborg" -> "goteborg").
export const stringToSlug = (str: string): string => {
  let slug = str.trim().toLowerCase()

  const from = 'àáäâåèéëêìíïîòóöôùúüûñçěščřžýúůďťň·/_,:;'
  const to = 'aaaaaeeeeiiiioooouuuuncescrzyuudtn------'
  for (let i = 0; i < from.length; i += 1) {
    slug = slug.replaceAll(from.charAt(i), to.charAt(i))
  }

  return slug
    .replace('.', '-')
    .replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
}
